const SORT_ORDER_ENUMS = {
  NONE: "none",
  ASC: "ascending",
  DESC: "descending"
};
const LAYOUT = {
  AUTO: "auto",
  FIXED: "fixed"
};
export {
  LAYOUT,
  SORT_ORDER_ENUMS
};
//# sourceMappingURL=constants.mjs.map
